<!--
    props
        composers
        editora
    events
        composers_changed
        remove_person

-->
<template >
    <v-flex xs12 md12>
        <v-form>
            <v-expansion-panels v-model="panel" :accordion="false" class="py-5" multiple :style="get_panels_style()">
                <template v-for="(person, indice) in composers" >
                <v-expansion-panel 
                    v-if="person.pivot.publisher_id == publisher_id"  
                    class="px-3" 
                    :key="person.row_count"
                    
                    >
                    <v-expansion-panel-header>
                        Compositor(a) {{ textoCompositorCombinado }} {{person.name}}
                        <template v-slot:actions>
                            <v-icon color="primary">$vuetify.icons.expand</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-layout wrap  grid-list-xl>
                            <v-flex xs12 :md3="publisher_id==null" :md6="publisher_id!=null" pr-1>
                                <v-text-field
                                    outlined
                                    v-model="person.name"
                                    class="purple-input"
                                    label="Nome Completo"
                                    :disabled="person.id!=null"
                                />
                            </v-flex>

                            <v-flex xs12 :md3="publisher_id==null" :md5="publisher_id!=null">
                                <v-text-field                                 
                                    outlined
                                    v-model="person.alias"
                                    class="purple-input ml-3"
                                    label="Nome artistico/pseudônimo"
                                    
                                />
                            </v-flex>

                             <v-flex xs12 md3 v-if="publisher_id==null">
                                <v-text-field
                                outlined
                                    v-model="person.pivot.br_cpf_cnpj"
                                    class="purple-input ml-3"
                                    label="CPF"
                                    messages="Precisamos dessa informação para enviar ao ECAD caso o ISRC tenha sido adquirido na nossa plataforma."
                                    v-mask="'###.###.###-##'"
                                />
                            </v-flex>

                            <v-flex xs12 md2 v-if="publisher_id==null">
                                <v-text-field
                                outlined
                                    v-model="person.pivot.share"
                                    class="purple-input ml-3"
                                    label="Participação em %"
                                    messages="Porcentagem desse compositor sobre esta obra."
                                    v-money="money"
                                    suffix="%"                                   
                                    
                                />
                            </v-flex>

                            <v-flex xs12 md1>
                                <v-btn
                                    class="ml-5"
                                    fab
                                    @click="remove_person(indice)"
                                    color="red"
                                    small
                                    dark
                                >
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                </template>
            </v-expansion-panels>
        </v-form>
    </v-flex>
</template>

      <script>
import Vue from "vue";

import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

export default {
    props: {
        composers: Array,
        publisher_id: Number
    },
    $_veeValidate: {
        validator: "new"
    },
 
    data: () => {
        return {
            meu_indice:1,
            panel: [0, 1, 2, 4, 5, 6],
            composers_array: [],
            money: {
                decimal: ".",
                thousands: "",
                precision: 2

                //masked: false /* doesn't work with directive */
            },
            dictionary: {
                custom: {
                    share: {
                        required:
                            "É necessário selecionar definir um valor de participação, mesmo que seja zero ( 0 )",
                        max: "O valor máximo é 100."
                    }
                }
            }
        };
    },

    mounted: function() {
        this.$validator.localize("pt_br", this.dictionary);
      
        //console.log("EDITORA ", this.publisher_id);
    },
    beforeUpdate: function() {
        //console.log("listagem, beforeUdate ", this.composers);
        //this.composers_array = this.composers;
        //this.panel = this.composers.map( (e,i) =>{return i});
        //   console.log(this.panel);
    },
    computed: {
        textoCompositorCombinado: function() {
            return this.publisher_id != null ? "- EDITORA -" : "-"; //INDEPENTEND
        }
    },
    watch: {
       
    },
    methods: {
        remove_person(indice) {
            console.log("remove_person child ", indice)
            this.$emit("remove_composer", indice);              
        },
        /**
         * Tive que forçar a barra aqui
         */
        changed_element(person) {
            //this.$emit('composers_changed', this.composers_array);
        },
        get_panels_style(){
            return this.publisher_id!=null ? 'margin-left:5%; width:90%' :'' ;
        }
    }
};
</script>